import * as React from 'react';
import { forwardRef } from 'react';

export type DMAnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const DMAnchor = forwardRef<HTMLAnchorElement, DMAnchorProps>(
  ({ className = '', children, ...props }, ref) => {
    return (
      <a ref={ref} className={className} {...props}>
        {children}
      </a>
    );
  },
);
DMAnchor.displayName = 'DMAnchor';
